import styled from 'styled-components';

const BaseStyle = styled.div`
  color: #fff;
  width: 100%;
`;

export const HeaderTopGradient = BaseStyle.extend`
  height: 5px;
  padding: 5px;
  background: linear-gradient(to right, #fff 40%, #f99622);
`;

export const UtilityMenuBottomGradient = BaseStyle.extend`
  height: 2px;
  padding: 2px;
  background: linear-gradient(to right, #fff 40%, #2376c8);
`;



// WEBPACK FOOTER //
// ./src/modules/layout/components/Gradients.js